import { CustomerServiceOutlined, FileOutlined, FilePdfOutlined, PlaySquareOutlined } from '@ant-design/icons';
import { Button } from '../index';
import { FileTypes } from '../../constants/common';

const FileTypeButton = ({ data, row, handleDownloadPdf, ...rest }) => {
  if (!data) return '';
  let icon = <FileOutlined />;
  if (data === FileTypes.pdf) {
    icon = <FilePdfOutlined />;
    return (
      <Button
        // onClick={() => handleDownloadPdf(row.id, row?.file?.file_name)}
        type={'green'}
        icon={icon}
      />
    );
  } else if (data === FileTypes.video) {
    icon = <PlaySquareOutlined />;
  } else if (data === FileTypes.music) {
    icon = <CustomerServiceOutlined />;
  }

  return (
    <Button type={'green'} icon={icon} {...rest} />
  );
};

export default FileTypeButton;
